import { LiteralHeadersTableTitles } from '../../consts';
import { DatosPerfilesUsuario } from '../../store/usuarios/types';

const orderIconConstant = 'Icono de ordenar';

export const getHeaderPractice = (profileActive: DatosPerfilesUsuario) => {
  let fields: any = [];

  const commonFields = [
    { text: LiteralHeadersTableTitles.CURSO },
    {
      text: LiteralHeadersTableTitles.INICIO_SERVICIO,
      orderBy: 'asc',
      ariaLabelIcon: orderIconConstant,
    },
    {
      text: LiteralHeadersTableTitles.FIN_SERVICIO,
      orderBy: 'desc',
      ariaLabelIcon: orderIconConstant,
    },
    { text: LiteralHeadersTableTitles.MINUTOS },
    { text: LiteralHeadersTableTitles.TIPO_PRACTICA },
    { text: LiteralHeadersTableTitles.TREN },
  ];

  if (
    profileActive?.ID_PERFIL === '111' ||
    profileActive?.ID_PERFIL === '112' ||
    profileActive?.ID_PERFIL === '121' ||
    profileActive?.ID_PERFIL === '122' ||
    profileActive?.ID_PERFIL === '123'
  ) {
    fields = [
      ...commonFields,

      { text: LiteralHeadersTableTitles.INSTRUCTOR_TOOLTIP },
      { text: LiteralHeadersTableTitles.ID_INSTRUCTOR },
      { text: LiteralHeadersTableTitles.INSTRUCTOR_NOMBRE },
      { text: LiteralHeadersTableTitles.ESTADO },
      
    ];
  } else if (profileActive?.ID_PERFIL === '211') {
    fields = [
      ...commonFields,

      { text: LiteralHeadersTableTitles.ID_ALUMNO },
      { text: LiteralHeadersTableTitles.ALUMNO_TOOLTIP },
      { text: LiteralHeadersTableTitles.TIPO_ALUMNO },
      { text: LiteralHeadersTableTitles.TIPO_PERFIL },
      { text: LiteralHeadersTableTitles.ESTADO },
      { text: LiteralHeadersTableTitles.INSTRUCTOR_NOMBRE },
      { text: LiteralHeadersTableTitles.INSTRUCTOR_TOOLTIP },
    ];
  } else {
    fields = [
      ...commonFields,

      { text: LiteralHeadersTableTitles.ID_INSTRUCTOR },
      { text: LiteralHeadersTableTitles.INSTRUCTOR_NOMBRE },
      { text: LiteralHeadersTableTitles.INSTRUCTOR_TOOLTIP },
      { text: LiteralHeadersTableTitles.ID_ALUMNO },
      { text: LiteralHeadersTableTitles.ALUMNO_TOOLTIP },
      { text: LiteralHeadersTableTitles.TIPO_ALUMNO },
      { text: LiteralHeadersTableTitles.TIPO_PERFIL },
      { text: LiteralHeadersTableTitles.ESTADO },
    ];
  }

  return fields;
};

export const getHeaderAudit = () => {
  const fields = [
    { text: LiteralHeadersTableTitles.CURSO },
    {
      text: LiteralHeadersTableTitles.INICIO_SERVICIO,
      orderBy: 'asc',
      ariaLabelIcon: orderIconConstant,
    },
    {
      text: LiteralHeadersTableTitles.FIN_SERVICIO,
      orderBy: 'desc',
      ariaLabelIcon: orderIconConstant,
    },
    { text: LiteralHeadersTableTitles.MINUTOS },
    { text: LiteralHeadersTableTitles.TIPO_PRACTICA },
    { text: LiteralHeadersTableTitles.RUTA },
    { text: LiteralHeadersTableTitles.TREN },
    { text: LiteralHeadersTableTitles.MORE_INFORMATION },
    { text: LiteralHeadersTableTitles.ALUMNO },
    { text: LiteralHeadersTableTitles.INSTRUCTOR },
    { text: LiteralHeadersTableTitles.ESTADO },
    // { text: LiteralHeadersTableTitles.SELECCIONAR },
    { text: '', checkRow: 'false' },
    { text: LiteralHeadersTableTitles.VER, hideResponsive: true },
  ];

  return fields;
};

export const getHeaderAuditExcel = () => {

  const fields = [
    { text: LiteralHeadersTableTitles.CURSO },
    {
      text: LiteralHeadersTableTitles.INICIO_SERVICIO,
      orderBy: 'asc',
      ariaLabelIcon: orderIconConstant,
    },
    {
      text: LiteralHeadersTableTitles.FIN_SERVICIO,
      orderBy: 'desc',
      ariaLabelIcon: orderIconConstant,
    },
    { text: LiteralHeadersTableTitles.MINUTOS },
    { text: LiteralHeadersTableTitles.TIPO_PRACTICA },
    { text: LiteralHeadersTableTitles.RUTA },
    { text: LiteralHeadersTableTitles.TREN },
    { text: LiteralHeadersTableTitles.MORE_INFORMATION },
    { text: LiteralHeadersTableTitles.ESTADO },
    // { text: LiteralHeadersTableTitles.SELECCIONAR },
    { text: '', checkRow: 'false' },
    { text: LiteralHeadersTableTitles.VER, hideResponsive: true },
  ];

  return fields;
};